export default __webpack_public_path__ + "static/media/Inter-SemiBold.4d56bb21.ttf";